function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgPharmaceutical = function SvgPharmaceutical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 498 498",
    xmlSpace: "preserve",
    y: "0px",
    x: "0px",
    id: "Capa_1_1565755547687",
    width: 70,
    height: 69,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456,144H296c-2.736,0-5.416,0.28-8,0.808v-6.688c0-13.976-7.448-27.112-19.424-34.296L251.88,93.808    c-2.4-1.44-3.88-4.064-3.88-6.856V64h24V0H16v64h24v22.944c0,2.792-1.488,5.424-3.88,6.856l-16.696,10.016    C7.448,111,0,124.144,0,138.12V392c0,22.056,17.944,40,40,40h216v24c0,22.056,17.944,40,40,40h160c22.056,0,40-17.944,40-40V184    C496,161.944,478.056,144,456,144z M32,48V16h224v32H32z M256,376h-32v16h32v24H40c-13.232,0-24-10.768-24-24h192v-16H16V184h240    V376z M259.392,168H16v-29.88c0-8.384,4.472-16.264,11.656-20.576l16.696-10.016C48.816,104.84,52.056,100.704,54,96h34V80H56V64    h176v16H104v16h130c1.944,4.704,5.176,8.84,9.648,11.52l16.696,10.016c7.184,4.312,11.656,12.2,11.656,20.584V152h0.248    C266.696,156.136,262.208,161.592,259.392,168z M480,456c0,13.232-10.768,24-24,24H296c-13.232,0-24-10.768-24-24V184    c0-13.232,10.768-24,24-24h160c13.232,0,24,10.768,24,24V456z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 288,
    width: 16,
    y: 176,
    x: 368,
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320,208c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S333.232,208,320,208z M320,240c-4.416,0-8-3.592-8-8    s3.584-8,8-8c4.416,0,8,3.592,8,8S324.416,240,320,240z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432,208c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S445.232,208,432,208z M432,240c-4.416,0-8-3.592-8-8    s3.584-8,8-8c4.416,0,8,3.592,8,8S436.416,240,432,240z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320,272c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S333.232,272,320,272z M320,304c-4.416,0-8-3.584-8-8    c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8C328,300.416,324.416,304,320,304z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432,272c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S445.232,272,432,272z M432,304c-4.416,0-8-3.584-8-8    c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8C440,300.416,436.416,304,432,304z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320,336c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S333.232,336,320,336z M320,368c-4.416,0-8-3.584-8-8    c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8C328,364.416,324.416,368,320,368z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432,336c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S445.232,336,432,336z M432,368c-4.416,0-8-3.584-8-8    c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8C440,364.416,436.416,368,432,368z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M320,400c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S333.232,400,320,400z M320,432c-4.416,0-8-3.584-8-8    c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8C328,428.416,324.416,432,320,432z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432,400c-13.232,0-24,10.768-24,24s10.768,24,24,24s24-10.768,24-24S445.232,400,432,400z M432,432c-4.416,0-8-3.584-8-8    c0-4.416,3.584-8,8-8c4.416,0,8,3.584,8,8C440,428.416,436.416,432,432,432z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.4,200h-2.096c-7.472,0-14.928,2.096-22.184,6.24c-3.984,2.272-6.24,2.28-10.24,0    c-7.256-4.144-14.712-6.24-22.184-6.24H114.6C91.112,200,72,219.112,72,242.608v6.072c0,16.704,4.544,33.112,13.144,47.44    C92.248,307.96,96,321.52,96,335.32v3.832C96,350.648,105.352,360,116.848,360c10.312,0,19.184-7.696,20.648-17.896l5.288-37.048    c0.168-1.216,2.248-1.216,2.424,0l5.288,37.048c1.464,10.2,10.336,17.896,20.656,17.896c11.496,0,20.848-9.352,20.848-20.848    v-3.832c0-13.808,3.76-27.36,10.856-39.2c8.6-14.328,13.144-30.736,13.144-47.448V242.6C216,219.112,196.888,200,173.4,200z     M200,248.672c0,13.808-3.76,27.36-10.856,39.208c-8.6,14.328-13.144,30.736-13.144,47.44v3.832c0,2.672-2.176,4.848-4.848,4.848    c-2.4,0-4.472-1.792-4.808-4.168l-5.288-37.048C159.848,294.36,152.512,288,144,288c-8.512,0-15.848,6.36-17.056,14.792    l-5.288,37.048c-0.336,2.368-2.408,4.16-4.808,4.16c-2.672,0-4.848-2.176-4.848-4.848v-3.832c0-16.704-4.544-33.112-13.144-47.44    C91.76,276.04,88,262.488,88,248.672V242.6c0-14.664,11.928-26.6,26.6-26.6h2.096c4.656,0,9.448,1.392,14.248,4.128    c8.984,5.144,17.136,5.136,26.104,0c4.816-2.744,9.6-4.136,14.256-4.136h2.096C188.072,216,200,227.936,200,242.608V248.672z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.968,234.04c-13.888,7.912-28.04,7.912-41.976-0.016l-7.904,13.904C124.496,253.288,134.216,256,144,256    s19.504-2.712,28.888-8.056L164.968,234.04z",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 16,
    width: 40,
    y: 312,
    x: 32,
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 16,
    width: 40,
    y: 344,
    x: 32,
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(13, 86, 164)"
    }
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPharmaceutical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pharmaceutical.c5ea4633.svg";
export { ForwardRef as ReactComponent };